import { Button, Grid, Heading, Text } from '@simplywallst/ui-core';

import { useTypeformDrawer } from '@/hooks/useTypeformDrawer';

import { Wrapper } from './styled';

type Props = {
  onBlur?: () => void;
  onFocus?: () => void;
  close?: () => void;
};

export const DropdownEmptyState = ({ onFocus, onBlur, close }: Props) => {
  const makeTypeformPopup = useTypeformDrawer('AnZWHEfM');

  return (
    <Wrapper
      gap="24px"
      gapMd="16px"
      placeItems="center"
      placeContent="center"
      templateColumns="minmax(min-content, max-content)"
    >
      <Grid
        gap="4px"
        placeContent="center"
        templateColumns="minmax(min-content, 350px)"
      >
        <Heading
          as="h3"
          color="spaceGray"
          textAlign="center"
          typography="smallStrong"
        >
          Can't find your broker?
        </Heading>
        <Text typography="xSmall" color="spaceGray" textAlign="center">
          Let us know your broker, and we'll notify you when it becomes
          available
        </Text>
      </Grid>
      <Button
        onBlur={onBlur}
        onFocus={onFocus}
        styleType="louderLarge"
        onClick={() => {
          makeTypeformPopup();
          close?.();
        }}
      >
        Request my broker
      </Button>
    </Wrapper>
  );
};
